import { ResourceModel } from "../../generics/models/generic-resource-model";

export class RolePermission extends ResourceModel<RolePermission> {
  public id: number;
  public isEnabled: boolean;
  public frontEndViewID: number;
  public frontEndPermissionID: number;
  public roleID: number;

  constructor(model?: Partial<RolePermission>) {
    super(model);
  }
}
